import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11c478aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pay-title" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "pay-info" }
const _hoisted_4 = {
  key: 0,
  class: "order-no"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, "订单编号:", -1))
const _hoisted_6 = { class: "right" }
const _hoisted_7 = { class: "order-price" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, "应付齿轮币:", -1))
const _hoisted_9 = { class: "right" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))
const _hoisted_11 = { class: "user-total" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, [
      (_ctx.creatOrderInfo.data.nu)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "订单提交成功，"))
        : _createCommentVNode("", true),
      _createTextVNode("正在等待付款...")
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.creatOrderInfo.data.nu)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.creatOrderInfo.data.nu), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createTextVNode(_toDisplayString(_ctx.creatOrderInfo.data.price), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createTextVNode(" 账户余额："),
      _createElementVNode("span", null, [
        _hoisted_12,
        _createTextVNode(_toDisplayString(_ctx.creatOrderInfo.data.gear), 1)
      ])
    ])
  ]))
}